<template>
  <el-checkbox-group
    v-if="props.config.options?.length"
    v-bind="$attrs"
    @change="val => $emit('change', val)"
  >
    <el-checkbox
      v-for="(config, index) in props.config.options"
      :key="index"
      :label="config.label"
    >
      {{ t(config.label || "") }}
    </el-checkbox>
  </el-checkbox-group>
  <el-checkbox
    v-else
    v-bind="$attrs"
    :label="config.value"
    @change="val => $emit('change', val)"
  />
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "form-checkbox",
  inheritAttrs: false,
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    const { t } = useI18n();
    return {
      t,
      props
    };
  }
});
</script>
